<div>
  <button mat-button
          color="primary"
          type="button"
          (click)="show = !show">{{ getButtonTitle() }}</button>

  <ng-container *ngIf="show">
    <ub-table [bordered]="true" [striped]="true" rowsize="sm"  *ngIf="logs.length > 0; else noActivityTemplate">
      <thead light>
        <th i18n>User</th>
        <th i18n>Action</th>
        <th i18n>Date</th>
        <th i18n>Details</th>
      </thead>
      <tbody>
        <tr *ngFor="let log of logs">
          <td>
            <span *ngIf="!log.masquerade">
              <eas-user-title username="{{ log.actor }}"></eas-user-title>
            </span>
            <span *ngIf="log.masquerade">
              <eas-user-title username="{{ log.masquerade }}"></eas-user-title> <ng-container i18n>as</ng-container>
              <eas-user-title username="{{ log.actor }}"></eas-user-title>
            </span>
          </td>
          <td>
            {{ mapping[log.action] ?? log.action }}
          </td>
          <td>
            {{ log.date | date:'medium' }}
          </td>
          <td>
            <ul *ngIf="log.extra?.actions; let actions">
              <li *ngFor="let action of actions">
                {{ action.id }}
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </ub-table>

    <ng-template #noActivityTemplate>
      <p i18n>There has been no activity...</p>
    </ng-template>
  </ng-container>
</div>
